export const SELECT_BOX_TYPES = {
  SMARTLISTS: "smartlists",
  OFFERS: "offers",
  SEASONS: "seasons",
  FREE: "free",
} as const;

export type SelectBoxType =
  (typeof SELECT_BOX_TYPES)[keyof typeof SELECT_BOX_TYPES];
